import { render } from "./PublicLayout.vue?vue&type=template&id=61b514fa&scoped=true&ts=true"
import script from "./PublicLayout.vue?vue&type=script&lang=ts"
export * from "./PublicLayout.vue?vue&type=script&lang=ts"

import "./PublicLayout.vue?vue&type=style&index=0&id=61b514fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b514fa"]])

export default __exports__